import type { GridColDef } from "@mui/x-data-grid";

/**
 * Column definitions for the Lex Bots DataGrid.
 * Each column maps directly to a field in LexBotInfo.
 * The composite `id` column is hidden — it is only used as the DataGrid row key.
 */
export const LEX_BOT_COLUMNS: GridColDef[] = [
  {
    field: "botName",
    headerName: "Bot Name",
    flex: 1.5,
    minWidth: 160,
  },
  {
    field: "botAliasName",
    headerName: "Alias",
    flex: 1.5,
    minWidth: 140,
  },
  {
    field: "botVersion",
    headerName: "Version",
    flex: 0.6,
    minWidth: 80,
  },
  {
    field: "localeId",
    headerName: "Language",
    flex: 0.8,
    minWidth: 90,
  },
];
